module.exports = __webpack_public_path__ + "static/img/logo17.55252db4.png";